
import { trackClick } from '@marketplace/helpers/segment/index.js'
import debounce from 'lodash/debounce'

export default {
    name: 'ProductQuantityIncrementor',
    props: {
        isDisabled: {
            type: Boolean,
            default: false,
        },
        initialQuantity: {
            type: Number,
            default: 0,
        },
        preventZeroInput: {
            type: Boolean,
            default: false,
        },
        maxValue: {
            type: Number,
            default: undefined,
        },
        inputName: {
            type: String,
            default: null,
        },
        styleOption: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['normal', 'small', 'borderless'].includes(value)
                // small is just smaller, borderless has no additional styles
            },
        },
        trackingCategory: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            currentValue: 0,
        }
    },
    watch: {
        initialQuantity: function (val) {
            this.currentValue = val
        },
    },
    mounted() {
        // if there is a initialQuantity set we still need to call back the value
        if (
            this.initialQuantity > 0 &&
            this.currentValue !== this.initialQuantity
        ) {
            this.currentValue = this.initialQuantity
            this.$emit('itemQuantityCallback', this.currentValue)
        }
    },
    methods: {
        updateValue(payload) {
            if (!this.isDisabled) {
                if (payload === '+') {
                    if (this.maxValue && this.maxValue <= this.currentValue) {
                        this.currentValue = this.maxValue
                    } else {
                        this.currentValue++
                    }

                    this.trackIncrement({ changeType: 'plus' })
                } else if (payload === '-') {
                    if (this.preventZeroInput) {
                        this.currentValue - 1 <= 0
                            ? (this.currentValue = 1)
                            : this.currentValue--
                    } else {
                        this.currentValue - 1 <= 0
                            ? (this.currentValue = 0)
                            : this.currentValue--
                    }

                    this.trackIncrement({ changeType: 'minus' })
                } else {
                    let value = parseInt(payload.target.value)
                    this.trackInput()

                    if (this.preventZeroInput && value <= 0) {
                        value = 1
                    } else if (value <= 0) {
                        value = 0
                    }
                    this.currentValue = value
                    if (this.maxValue && this.currentValue >= this.maxValue) {
                        this.currentValue = this.maxValue
                    }
                }

                this.$emit('itemQuantityCallback', this.currentValue)
            }
        },

        trackIncrement(context) {
            if (!this.trackingCategory) {
                return
            }

            trackClick('Quantity Change', {
                ...{ category: this.trackingCategory },
                ...context,
            })
        },

        trackInput: debounce(function () {
            if (!this.trackingCategory) {
                return
            }

            trackClick('Quantity Change', {
                category: this.trackingCategory,
                changeType: 'number input',
            })
        }, 500),
    },
}
